/**
 * Notification module constants
 */

// Dismissal periods
export const NOTIFICATION_SETTINGS_POPOVER_DISMISSAL_PERIOD_MS = 180 * 24 * 60 * 60 * 1000 // 180 days

// UI constants
export const NOTIFICATION_SIDEBAR_Z_INDEX = 9
export const NOTIFICATION_MARK_READ_DELAY_MS = 1000
